/* Compassionate Beauty - Hair Colour visual swatch picker v5
   Anti-flicker: init() runs synchronously in MutationObserver - no delay.
   Dawn AJAX re-renders the section on variant change; we rebuild the grid
   in the same tick so there is zero visible gap. */
(function () {
  'use strict';

  // Gallery image switching by filename - used because variants have no featured_media assigned
  var _lastSwatchColor = null;

  function switchGalleryToColor(colorVal) {
    _lastSwatchColor = colorVal;
    var gallery = document.querySelector('media-gallery');
    if (!gallery || !gallery.setActiveMedia) return;
    var items = gallery.querySelectorAll('ul li[data-media-id]');
    if (!items.length) return;

    var normUnderscore = colorVal.toLowerCase().replace(/\//g, '_').replace(/\s+/g, '_');
    var normAlpha = colorVal.toLowerCase().replace(/[^a-z0-9]/g, '');
    if (!normAlpha) return;

    function lcsLen(a, b) {
      var m = a.length, n = b.length;
      if (!m || !n) return 0;
      var prev = new Array(n + 1).fill(0);
      var curr = new Array(n + 1).fill(0);
      var best = 0;
      for (var i = 1; i <= m; i++) {
        for (var j = 1; j <= n; j++) {
          if (a.charCodeAt(i - 1) === b.charCodeAt(j - 1)) {
            curr[j] = prev[j - 1] + 1;
            if (curr[j] > best) best = curr[j];
          } else {
            curr[j] = 0;
          }
        }
        var tmp = prev; prev = curr; curr = tmp;
        for (var k = 0; k <= n; k++) curr[k] = 0;
      }
      return best;
    }

    function filenameFromLi(li) {
      var img = li.querySelector('img');
      if (!img) return '';
      var src = img.getAttribute('src') || '';
      var alt = img.getAttribute('alt') || '';
      var name = (src.split('/').pop() || '').split('?')[0];
      return (name + ' ' + alt).toLowerCase().replace(/[^a-z0-9]/g, '');
    }

    for (var p = 0; p < items.length; p++) {
      var fn = filenameFromLi(items[p]);
      if (fn.indexOf(normAlpha) !== -1 || fn.indexOf('_' + normUnderscore + '_') !== -1) {
        gallery.setActiveMedia(items[p].dataset.mediaId, true);
        return;
      }
    }

    var bestScore = 0;
    var bestId = null;
    var threshold = Math.max(4, Math.floor(normAlpha.length * 0.6));
    for (var q = 0; q < items.length; q++) {
      var fn2 = filenameFromLi(items[q]);
      if (!fn2) continue;
      var score = lcsLen(normAlpha, fn2);
      if (score > bestScore && score >= threshold) {
        bestScore = score;
        bestId = items[q].dataset.mediaId;
      }
    }
    if (bestId) gallery.setActiveMedia(bestId, true);
  }

  const SWATCH_BASE = 'https://compassionatebeauty.com/cdn/shop/t/11/assets/';
  const DONE_ATTR   = 'data-cb-swatch-done';

  function normalizeCode(val) {
    return val.toLowerCase().replace(/\//g, '-').replace(/\s+/g, '-');
  }

  function swatchUrl(val) {
    return SWATCH_BASE + normalizeCode(val) + '_50x.png';
  }

  function getCurrentSelected(fieldset) {
    const checked = fieldset.querySelector('input[type="radio"]:checked');
    return checked ? checked.value : null;
  }

  function buildSwatchGrid(fieldset) {
    const legendEl   = fieldset.querySelector('legend, .form__label');
    const optionName = legendEl ? legendEl.textContent.split(':')[0].trim() : 'Hair Colour';
    const inputs     = Array.from(fieldset.querySelectorAll('input[type="radio"]'));
    if (!inputs.length) return null;

    const selectedVal = getCurrentSelected(fieldset);

    const wrapper = document.createElement('div');
    wrapper.className = 'cb-swatch-wrapper';

    const legend = document.createElement('div');
    legend.className = 'cb-swatch-legend';
    legend.innerHTML = optionName + ': <span class="cb-swatch-selected-val">' + (selectedVal || '') + '</span>';
    wrapper.appendChild(legend);

    const grid = document.createElement('div');
    grid.className = 'cb-swatch-grid';

    const items = [];

    inputs.forEach(function (input) {
      const val      = input.value;
      const isActive = input.checked;
      const isDis    = input.disabled;

      const item = document.createElement('div');
      item.className = 'cb-swatch-item' + (isActive ? ' is-active' : '') + (isDis ? ' is-disabled' : '');
      item.setAttribute('data-value', val);
      item.setAttribute('title', val);
      item.setAttribute('role', 'radio');
      item.setAttribute('aria-checked', isActive ? 'true' : 'false');
      item.setAttribute('aria-label', val);
      item.setAttribute('tabindex', isActive ? '0' : '-1');

      const imgWrap = document.createElement('div');
      imgWrap.className = 'cb-swatch-img-wrap';

      const img = document.createElement('img');
      img.src     = swatchUrl(val);
      img.alt     = val;
      img.width   = 60;
      img.height  = 60;
      img.loading = 'lazy';
      img.onerror = function () { item.classList.add('no-img'); };

      imgWrap.appendChild(img);
      item.appendChild(imgWrap);

      const label = document.createElement('span');
      label.className   = 'cb-swatch-label';
      label.textContent = val;
      item.appendChild(label);

      item.addEventListener('click', function () {
        if (isDis) return;

        // Update visual state INSTANTLY - before Dawn's AJAX re-render
        items.forEach(function (o) {
          const isThis = o.input === input;
          o.item.classList.toggle('is-active', isThis);
          o.item.setAttribute('aria-checked', isThis ? 'true' : 'false');
          o.item.setAttribute('tabindex', isThis ? '0' : '-1');
        });
        const sp = wrapper.querySelector('.cb-swatch-selected-val');
        if (sp) sp.textContent = val;

        // Notify Shopify - this triggers Dawn's AJAX section re-render
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        // Switch gallery image to match this colour by filename
        switchGalleryToColor(val);
      });

      grid.appendChild(item);
      items.push({ item, input });
    });

    wrapper.appendChild(grid);

    // Sync when Shopify externally changes the variant (URL param, size option, etc.)
    function syncActive() {
      var checkedVal = getCurrentSelected(fieldset);
      items.forEach(function (o) {
        var active = o.input.value === checkedVal;
        o.item.classList.toggle('is-active', active);
        o.item.setAttribute('aria-checked', active ? 'true' : 'false');
      });
      var sp = wrapper.querySelector('.cb-swatch-selected-val');
      if (sp) sp.textContent = checkedVal || '';
    }

    fieldset.addEventListener('change', syncActive);
    new MutationObserver(syncActive).observe(fieldset, {
      subtree: true, attributes: true, attributeFilter: ['checked', 'disabled']
    });

    return wrapper;
  }

  function init() {
    var fieldsets = document.querySelectorAll('[data-cb-colour="true"]:not([' + DONE_ATTR + '])');
    fieldsets.forEach(function (fieldset) {
      fieldset.setAttribute(DONE_ATTR, '1');
      var swatchWrapper = buildSwatchGrid(fieldset);
      if (!swatchWrapper) return;
      fieldset.parentNode.insertBefore(swatchWrapper, fieldset);
    });
  }

  // ?? Trigger 1: DOMContentLoaded ??????????????????????????????????
  document.addEventListener('DOMContentLoaded', init);

  // ?? Trigger 2: window.load (backup for slow pages) ???????????????
  window.addEventListener('load', init);

  // ?? Trigger 3: Watch for Dawn's AJAX section re-renders ??????????
  // Dawn replaces #ProductInfo-{id} innerHTML on every variant change.
  // This destroys our swatch grid. We detect the new DOM and re-init
  // SYNCHRONOUSLY (no setTimeout) so there is zero visible gap.
  function watchForDawnRerenders() {
    new MutationObserver(function (mutations) {
      var hit = false;
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if (
            n.tagName === 'VARIANT-SELECTS' ||
            n.hasAttribute('data-cb-colour') ||
            (n.querySelector && (
              n.querySelector('variant-selects') ||
              n.querySelector('[data-cb-colour]')
            ))
          ) {
            hit = true;
            break;
          }
        }
        if (hit) break;
      }
      // Synchronous init - no delay - runs in the same MutationObserver callback
      if (hit) {
        init();
        // Re-apply gallery colour switch after Dawn section re-render
        if (_lastSwatchColor) { setTimeout(function() { switchGalleryToColor(_lastSwatchColor); }, 50); }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (window.customElements) {
    customElements.whenDefined('variant-selects').then(function () {
      init();
      watchForDawnRerenders();
    });
  } else {
    watchForDawnRerenders();
  }

  // ?? Trigger 4: theme editor section reloads ???????????????????????
  // Native Dawn Color option listener (for products not using cb-swatches)
  document.addEventListener('change', function(e) {
    var input = e.target;
    if (input.type !== 'radio') return;
    var fieldset = input.closest('fieldset');
    if (!fieldset || fieldset.hasAttribute(DONE_ATTR)) return;
    var legend = fieldset.querySelector('.form__label');
    if (!legend) return;
    var optName = legend.textContent.split(':')[0].trim().toLowerCase();
    if (optName !== 'color' && optName !== 'colour') return;
    switchGalleryToColor(input.value);
  });

  document.addEventListener('shopify:section:load', init);

})();

